// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jO8d","newExpiryDate":"styles_newExpiryDate__MYKS1","footer":"styles_footer__1aATv"};